import { render } from "./addNewCorporate.vue?vue&type=template&id=1941b5f4"
import script from "./addNewCorporate.vue?vue&type=script&lang=js"
export * from "./addNewCorporate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__